import { ref } from 'vue'

export interface ConfirmOptions {
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'danger' | 'primary'
}

interface PendingConfirm {
  message: string
  options: ConfirmOptions
  resolve: (value: boolean) => void
}

// Module-level singleton - one modal instance shared across the entire app
const pending = ref<PendingConfirm | null>(null)

export function useConfirmState() {
  return pending
}

export function showConfirm(message: string, options: ConfirmOptions = {}): Promise<boolean> {
  // If a confirm is already pending, resolve it with false (treat as cancelled) before replacing
  if (pending.value) {
    pending.value.resolve(false)
  }
  return new Promise((resolve) => {
    pending.value = { message, options, resolve }
  })
}
